import { useLocation, useNavigate } from 'react-router-dom';
import Figure from 'react-bootstrap/Figure';
import Button from 'react-bootstrap/Button';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Dropdown from 'react-bootstrap/Dropdown';
import Container from 'react-bootstrap/Container';
import notFoundCover from '../../assets/noImage.svg';
import './book.style.css';
import { useState, useEffect, useCallback } from 'react';
import BookService from '../../services/book.service';
import { BOOK_STATUS, getBookStatus } from './book-status.const';
import { ModalElement } from '../../components/modal/modalElement';

export function Book(){
    const { state } = useLocation();
    const navigate = useNavigate();
    
    const [selectedStatus, setSelectedStatus] = useState(BOOK_STATUS[0]);
    const [bookInformation, setBookInformation] = useState(state);
    const [instructionModal, setInstructionModal] = useState(false);
    const [myReadModal, setmyReadModal] = useState(false);

    useEffect(() => {
        if (bookInformation?.readingStatus && bookInformation.readingStatus.currentStatus) {
            const status = BOOK_STATUS.find(status => status.label.toLocaleLowerCase() === bookInformation.readingStatus.currentStatus.toLocaleLowerCase());
            setSelectedStatus(status);
        } else {
            setSelectedStatus(BOOK_STATUS[0]);
        }
    }, [bookInformation]);

    useEffect(() => {
        setBookInformation(state);
    }, [state])

    const openReadInstructions = () => {
        setInstructionModal(true)
    }

    const openMyReadModal = () => {
        setmyReadModal(true)
    }

    const redirectToTimer = () => {
        navigate('/timer', {state: bookInformation})
    }

    const buildReadingOptionButtons = useCallback(() => {
        if (selectedStatus.eventKey === '1') {
            return (
                <>
                    <Button className='minhaLeitura' onClick={() => openMyReadModal()} variant="secondary"> 
                        MINHA LEITURA
                    </Button>
                    <Button className='ler' onClick={() => openReadInstructions()} variant="secondary"> 
                        LER
                    </Button>
                </>
            );
        }
        // if (selectedStatus.eventKey === '2') {
        //     return (
        //         <Button className='ler' onClick={() => openReadInstructions()} variant="secondary"> 
        //             LER
        //         </Button>
        //     );
        // }
        if (selectedStatus.eventKey === '3') {
            return (
                <Button className='minhaLeitura' onClick={() => openMyReadModal()} variant="secondary"> 
                    MINHA LEITURA
                </Button>
            );
        }
        return <></>;
    }, [selectedStatus]);

    const checkIfBookIsAlreadyInReadings = async (status) => {
        const data = await BookService.handleBookStatus(bookInformation, status);
        
        setBookInformation(data);
    };

    const evaluateReadProgress = () => {
        const lastPageRead = bookInformation?.readingStatus?.currentPage || 0;
        const totalPages = bookInformation?.book?.pages || 0;
        return parseInt((lastPageRead * 100) / totalPages);
    }

    return (
        <>
            <h1>{bookInformation?.book?.title || bookInformation?.volumeInfo?.title || 'Não encontrado'}</h1>
            <Figure>
                <Figure.Image
                    width={171}
                    height={180}
                    alt={bookInformation?.book?.title || bookInformation?.volumeInfo?.title || 'Não encontrado'}
                    src={bookInformation?.book?.imageUrl || bookInformation?.volumeInfo?.imageLinks?.smallThumbnail || notFoundCover}
                    className="bookCover"
                />
                <Figure.Caption>
                    Avaliação: {bookInformation?.book?.rating || "Sem Avaliação"}
                </Figure.Caption>
            </Figure>
            <div className='bookInformation'>
                <ButtonGroup className='buttonGroup' size='lg'>
                    <Dropdown onSelect={(eventKey) => {
                        setSelectedStatus(getBookStatus(eventKey));
                        checkIfBookIsAlreadyInReadings(getBookStatus(eventKey).label);
                    }}>
                        <Dropdown.Toggle variant="secondary" id="dropdown-basic">
                           {selectedStatus.label}
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                            <Dropdown.Item eventKey="1">Lendo</Dropdown.Item>
                            <Dropdown.Item eventKey="2">Quero Ler</Dropdown.Item>
                            <Dropdown.Item eventKey="3">Lido</Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                    {buildReadingOptionButtons()}
                </ButtonGroup>
                
                <Container fluid='sm' className='bookDetails'>
                    <h2 className='subtitles'>Sinopse:</h2>
                    <p className='detail'>{bookInformation?.book?.description || bookInformation?.volumeInfo?.description || 'Não encontrado'}</p>

                    <h2 className='subtitles'>Autor:</h2>
                    <p className='detail'>{bookInformation?.book?.authors?.[0] || bookInformation?.volumeInfo?.authors?.[0] || 'Não encontrado'}</p>

                    <h2 className='subtitles'>Páginas:</h2>
                    <p className='detail'>{bookInformation?.book?.pages || bookInformation?.volumeInfo?.pageCount || 0 }</p>

                    <h2 className='subtitles'>Editora:</h2>
                    <p className='detail'> {bookInformation?.book?.publisher || bookInformation?.volumeInfo?.publisher || 'Não encontrado'}</p>
                </Container>
            </div>

            <ModalElement
                show={instructionModal}
                onHide={() => setInstructionModal(false)}     
            >
                <h2 className='modal-read-instructions-title'>Tenha o controle da sua leitura</h2>
                <p className='modal-read-instructions-text'>1. Ative o cronômetro e comece a ler.</p>
                <p className='modal-read-instructions-text'>2. Pause o cronômetro e informe a página de início e fim de leitura.</p>
                <Button className="btn-start-read" onClick={() => redirectToTimer()}>BORA LER</Button>
            </ModalElement>

            <ModalElement
                show={myReadModal}
                onHide={() => setmyReadModal(false)}     
            >
                <h2 className='modal-my-read-title'>Minha leitura</h2>
                <p className='modal-my-read-text'>Progresso ({bookInformation?.readingStatus?.currentPage || 0}/{bookInformation?.book?.pages}): {evaluateReadProgress()}%</p>
                <p className='modal-my-read-text'>Página que parei: {bookInformation?.readingStatus?.currentPage || 0}</p>
                <p className='modal-my-read-text'>Tempo de Leitura: {bookInformation?.readingStatus?.readingTime || '00:00:00'}</p>
            </ModalElement>
        </>
    )
}